import { render, staticRenderFns } from "./ncdc.vue?vue&type=template&id=dfeb1366&scoped=true"
import script from "./ncdc.vue?vue&type=script&lang=js"
export * from "./ncdc.vue?vue&type=script&lang=js"
import style0 from "./ncdc.vue?vue&type=style&index=0&id=dfeb1366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfeb1366",
  null
  
)

export default component.exports